if (!customElements.get("swiper-carousel")) {
  customElements.define(
    "swiper-carousel",
    class SwiperCarousel extends HTMLElement {
      constructor() {
        super();
        this.swiperEl = this.querySelector(`#${this.id} > .swiper`);
      }

      connectedCallback() {
        this.initSwiper();
      }

      initSwiper() {
        this.setupSwiperParams();
        this.swiperInstance = new Swiper(this.swiperEl, this.swiperParams);
        this.handleNestedCarousels();
      }

      setupSwiperParams() {
        const element = this;

        this.swiperParams = {
          allowTouchMove:
            this.getAttribute("allow-touch-move-mobile") === "true",
          observer: true,
          resizeObserver: true,
          watchSlidesProgress: true,
          loop: this.getAttribute("loop-slides") === "true",
          grabCursor: this.getAttribute("loop-slides") === "true",
          slidesOffsetBefore: this.getAttribute("slides-offset-before-mobile")
            ? Number(this.getAttribute("slides-offset-before-mobile"))
            : 0,
          slidesOffsetAfter: this.getAttribute("slides-offset-after-mobile")
            ? Number(this.getAttribute("slides-offset-after-mobile"))
            : 0,
          slidesPerView:
            this.getAttribute("slides-per-view-auto-mobile") === "true"
              ? "auto"
              : Number(this.getAttribute("slides-per-view-mobile")),
          spaceBetween: Number(this.getAttribute("space-between-mobile")),

          ...(this.getAttribute("enable-autoplay-mobile") === "true" && {
            autoplay: {
              delay: Number(this.getAttribute("autoplay-delay-mobile")),
              disableOnInteraction:
                this.getAttribute("disable-on-interaction-mobile") === "true",
            },
            speed: Number(this.getAttribute("animation-speed-mobile")),
          }),

          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            navigation: {
              nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
              prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
            },
          }),

          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            scrollbar: {
              el: `#${this.id} > carousel-nav-container > .swiper-scrollbar`,
              draggable: true,
              snapOnRelease: true,
              dragSize: 38,
            },
          }),

          ...(this.getAttribute("show-navigation-mobile") === "true" && {
            pagination: {
              el: `#${this.id} > carousel-nav-container > .swiper-pagination`,
              type: "fraction",
            },
          }),

          breakpoints: {
            769: {
              allowTouchMove: this.getAttribute("allow-touch-move") === "true",
              slidesOffsetBefore: this.getAttribute("slides-offset-before")
                ? Number(this.getAttribute("slides-offset-before"))
                : 0,
              slidesOffsetAfter: this.getAttribute("slides-offset-after")
                ? Number(this.getAttribute("slides-offset-after"))
                : 0,
              slidesPerView:
                this.getAttribute("slides-per-view-auto-tablet") === "true"
                  ? "auto"
                  : Number(this.getAttribute("slides-per-view-tablet")),
              spaceBetween: Number(this.getAttribute("space-between-tablet")),
              loop: this.getAttribute("loop-slides") === "true",
              grabCursor: this.getAttribute("loop-slides") === "true",

              ...(this.getAttribute("show-navigation") === "true" && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              ...(this.getAttribute("enable-autoplay-tablet") === "true" && {
                autoplay: {
                  delay: Number(this.getAttribute("autoplay-delay")),
                  disableOnInteraction:
                    this.getAttribute("disable-on-interaction") === "true",
                },
                speed: Number(this.getAttribute("animation-speed-tablet")),
              }),

              ...(this.getAttribute("show-navigation") === "true" && {
                scrollbar: {
                  el: `#${this.id} > carousel-nav-container > .swiper-scrollbar`,
                  draggable: true,
                  snapOnRelease: true,
                  dragSize: 38,
                },
              }),

              ...(this.getAttribute("show-navigation") === "true" && {
                pagination: {
                  el: `#${this.id} > carousel-nav-container > .swiper-pagination`,
                  type: "fraction",
                },
              }),
            },
            1200: {
              allowTouchMove: this.getAttribute("allow-touch-move") === "true",
              slidesOffsetBefore: this.getAttribute("slides-offset-before")
                ? Number(this.getAttribute("slides-offset-before"))
                : 0,
              slidesOffsetAfter: this.getAttribute("slides-offset-after")
                ? Number(this.getAttribute("slides-offset-after"))
                : 0,
              slidesPerView:
                this.getAttribute("slides-per-view-auto") === "true"
                  ? "auto"
                  : Number(this.getAttribute("slides-per-view")),
              spaceBetween: Number(this.getAttribute("space-between")),
              loop: this.getAttribute("loop-slides") === "true",
              grabCursor: this.getAttribute("loop-slides") === "true",

              ...(this.getAttribute("show-navigation") === "true" && {
                navigation: {
                  nextEl: `#${this.id} > carousel-nav-container > .carousel-button-next`,
                  prevEl: `#${this.id} > carousel-nav-container > .carousel-button-prev`,
                },
              }),

              ...(this.getAttribute("enable-autoplay") === "true" && {
                autoplay: {
                  delay: Number(this.getAttribute("autoplay-delay")),
                  disableOnInteraction:
                    this.getAttribute("disable-on-interaction") === "true",
                },
                speed: Number(this.getAttribute("animation-speed")),
              }),

              ...(this.getAttribute("show-navigation") === "true" && {
                scrollbar: {
                  el: `#${this.id} > carousel-nav-container > .swiper-scrollbar`,
                  draggable: true,
                  snapOnRelease: true,
                  dragSize: 38,
                },
              }),

              ...(this.getAttribute("show-navigation") === "true" && {
                pagination: {
                  el: `#${this.id} > carousel-nav-container > .swiper-pagination`,
                  type: "fraction",
                },
              }),
            },
          },
          on: {
            init(swiper) {
              element.updateNavigationState(swiper);
              element.loadVisibleSlideVideos(swiper);
            },
            resize(swiper) {
              element.updateNavigationState(swiper);
              element.loadVisibleSlideVideos(swiper);
            },
            update(swiper) {
              element.updateNavigationState(swiper);
              element.loadVisibleSlideVideos(swiper);
            },
            setTransition(swiper, duration) {
              const container = swiper.el.parentElement;
              const bar = container?.querySelector(".progress-bar");
              if (bar) bar.style.transitionDuration = `${duration}ms`;
            },
            progress(swiper) {
              element.updateProgressBarFill(swiper);
            },
            slideChange(swiper) {
              element.loadVisibleSlideVideos(swiper);

              if (
                swiper.el.classList?.contains("dispatch-slide-change-event")
              ) {
                const event = new CustomEvent("swiper-carousel:slideChange", {
                  detail: {
                    sectionId: element.getAttribute("section-id"),
                    activeIndex: swiper.activeIndex,
                    previousIndex: swiper.previousIndex,
                  },
                });
                element.dispatchEvent(event);
              }
            },
            transitionEnd(swiper) {
              element.loadVisibleSlideVideos(swiper);
            },
          },
        };
      }

      loadVisibleSlideVideos(swiper) {
        const loadVideos = () => {
          const slides = swiper.el.querySelectorAll(
            ".swiper-slide-visible, .swiper-slide-active, .swiper-slide-next, .swiper-slide-prev",
          );

          slides.forEach((slide) => {
            slide.querySelectorAll("video-block").forEach((videoBlock) => {
              if (typeof videoBlock.loadCurrentVideo === "function") {
                videoBlock.loadCurrentVideo();
              } else {
                videoBlock
                  .querySelectorAll("video[autoplay]")
                  .forEach((video) => {
                    video.muted = true;
                    video.playsInline = true;
                    video.play().catch(() => {});
                  });
              }
            });
          });
        };

        if (customElements.get("video-block")) {
          loadVideos();
        } else {
          customElements.whenDefined("video-block").then(loadVideos);
        }
      }

      updateProgressBarFill(swiper) {
        const container = swiper.el.parentElement;
        const bar = container.querySelector(".progress-bar");

        if (!bar) return;

        const trackWidth = bar.offsetWidth;
        if (!trackWidth) return;

        const dragWidth = 38;
        const p = swiper.progress;
        const dragLeft = p * (trackWidth - dragWidth);
        const fillRight = dragLeft + dragWidth / 2;
        bar.style.setProperty(
          "--progress",
          `${((fillRight / trackWidth) * 100).toFixed(2)}%`,
        );
      }

      updateNavigationState(swiper) {
        const isAuto = swiper.params.slidesPerView === "auto";

        if (isAuto) {
          let totalSlidesWidth = 0;
          swiper.slides.forEach((slide) => {
            totalSlidesWidth += slide.offsetWidth + swiper.params.spaceBetween;
          });

          const fitsInContainer =
            totalSlidesWidth - swiper.params.spaceBetween <=
            swiper.width - swiper.params.slidesOffsetBefore;

          if (fitsInContainer) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }
        } else {
          const numberOfSlides = swiper.slides.length;

          if (numberOfSlides <= swiper.params.slidesPerView) {
            this.disableNavigation(swiper);
            swiper.disable();
          } else {
            this.enableNavigation(swiper);
            swiper.enable();
          }
        }

        // Disable prev button on first slide
        if (swiper.navigation?.prevEl) {
          if (swiper.activeIndex === 0) {
            swiper.navigation.prevEl.classList.add("swiper-button-disabled");
          } else {
            swiper.navigation.prevEl.classList.remove("swiper-button-disabled");
          }
        }
      }

      disableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.add("swiper-button-disabled");
          swiper.navigation.prevEl.classList.add("swiper-button-disabled");
        }
      }

      enableNavigation(swiper) {
        if (swiper.navigation?.nextEl && swiper.navigation?.prevEl) {
          swiper.navigation.nextEl.classList.remove("swiper-button-disabled");
          swiper.navigation.prevEl.classList.remove("swiper-button-disabled");
        }
      }

      handleNestedCarousels() {
        const nestedCarousels = this.querySelectorAll("swiper-carousel");
        if (nestedCarousels.length === 0) return;

        nestedCarousels.forEach((carousel) => {
          carousel.addEventListener("mouseenter", () => {
            this.swiperInstance.allowTouchMove = false;
          });
          carousel.addEventListener("mouseleave", () => {
            this.swiperInstance.allowTouchMove = true;
          });
        });
      }
    },
  );
}
